/**
 * @description axios方法封装
 * @author xuewt41684
 */

import axios from 'axios'
import qs from 'qs';
import t from '@/assets/lang/zh-CN';
import selfMsgBox from '@/components/SelfMsgBox';
import form from '@/assets/utils/form';
import hgx from '@/service/fund/hgx';
import router from '@/router';
import store from '@/store';
import ss from '@/assets/utils/ss';

var _datas = ''

function handleSlefMsg(msg) {
  selfMsgBox.error({
    message: t.error,
    messageExtra: msg,
    btns: ['确 认']
  })
}
function handelFixModify(msg){
  let currRouter = router.currentRoute.fullPath
  selfMsgBox.error({
    message: t.error,
    messageExtra: msg,
    btns: ['确 认'],
    onConfirm: () => {
      // 暂停/启用/终止 确认后不返回停留在当前页 修改定投页默认返回 修改定投页报错才跳转
      if (currRouter != '/fund-trans/fixed-trans' && currRouter != '/fund-trans/super-xjb/super-xjb') {
        router.go(-1)
      }
    }
  })
}
function handleSlefMsgBack(msg) {
  selfMsgBox.error({
    message: t.error,
    messageExtra: msg,
    btns: ['确 认'],
    onConfirm: () => {
      if (store.getters.newFixStepId == 2) {
        router.go(-2)
        return
      }
      if (ss.getItem('openTradeMsgBox')) {
        return;
      }
      router.go(-1)
    }
  })
}
// 身份证审核状态
function handleIdCardStatus(code, msg) {
  if (code == 'NWT-1026') {
    selfMsgBox.warning({
      message: '提示',
      messageExtra: "根据反洗钱相关法规要求，请上传您的身份证件照片",
      btns: ['立即上传', '取消'],
      onConfirm: () => {
        router.push({
          path: '/acco-query/acco-info'
        });
        ss.removeItem('openTradeMsgBox');
      },
      onClose:() => {
        if (store.getters.newFixStepId == 2) {
          router.go(-2)
          return
        }
        if (ss.getItem('openTradeMsgBox')) {
          return;
        }
        router.go(-1)
      }
    })
    return;
  }
  if (code == 'NWT-1024') {
    selfMsgBox.warning({
      message: '提示',
      messageExtra: msg,
      btns: ['确认'],
      onConfirm: () => {
        if (store.getters.newFixStepId == 2) {
          router.go(-2)
          return
        }
        if (ss.getItem('openTradeMsgBox')) {
          return;
        }
        router.back(-1)
      }
    })
    return;
  }
  if (code == 'NWT-1025') {
    selfMsgBox.warning({
      message: '提示',
      messageExtra: msg,
      btns: ['重新上传', '取消'],
      onConfirm: () => {
        router.push('/acco-query/acco-info').catch(err => {})
        ss.removeItem('openTradeMsgBox');
      },
      onClose: () => {
        if (store.getters.newFixStepId == 2) {
          router.go(-2)
          return
        }
        if (ss.getItem('openTradeMsgBox')) {
          return;
        }
        router.back(-1)
      }
    })
    return;
  }
  
}

// 风险测评低买高
function handleLowBuyHigh() {
  http.post(config.apiURL + '/account/account/queryBaseAccoinfo', {
    showfastmodeonly: false,
    querybankinfo: false,
    channel: 'web'
  }).then(({data: data}) => {
    const message = `您的风险承受能力是${data.riskabilityStr}，无法购买高于您风险承受能力的产品或服务。建议您终止交易或依据自身最新状况重新进行风险承受能力测评。`;
    selfMsgBox.warning({
      message: t.remind,
      messageExtra: message,
      onConfirm: () => {
        router.push('/forget/riskTest')
        
      },
      onClose:() => {
        if (store.getters.newFixStepId == 2) {
          router.go(-2)
          return
        }
        router.go(-1)
      },
      btns: ['重新风险测评', '终止交易']
    })
  })
}


  //交易下单 错误信息处理 // 错误码后四位决定，只需要判断后四位
function handleTradeMsg(code) {
  if (/^DS-TR.+?0102$/.test(code)) {
    const msg = '请输入正确的密码';
    selfMsgBox.error({
      message: '错误',
      messageExtra: msg,
      btns: ['确定']
    })
    return false;
  } else if (/^DS-TR(\w\w)?1353$/.test(code) || code.includes('1353')) {
    const msg = '您的交易密码已锁定'
    // 跳转解锁密码/忘记密码
    selfMsgBox.error({
      message: '错误',
      messageExtra: msg,
      btns:  ['立即重置', '取消'],
      onConfirm: () => {
        router.push('/forget/choseCard').catch(err => {})
      },
      onClose: () => {
        // 返回到上一路由
        // router.back(-1)
      }
    })
    return false;
  } else if (/^DS-TR.+?1049$/.test(code)) {
    // 开户证件已过期,跳转
    const msg = '开户证件已过期, 请修改证件有效期'
    selfMsgBox.warning({
      message: '提示',
      messageExtra: msg,
      btns: ['确定'],
      onConfirm: () => {
        router.push('/acco-query/acco-info').catch(err => {})
      }
    })
    return false;
  }
}

function handleSwitchDsCode(code, msg) {
  switch (code) {
    case 'DS-TR121146':
      break;
    case 'DS-TR141146':
      break;
    case 'DS-TR141663': // 定投工作日是否交易
      handelFixModify(msg)
      break;
    case 'DS-TR0U0119': // 没有设置相应的费率
      // handleSlefMsgBack(msg)
      break;
    case 'DS-TR12Z003': // 投资人
      handleSlefMsgBack(msg)
      break;
    case 'DS-TR0U0104': // 不允许做交易 
      handleSlefMsgBack(msg)
      break;
    case 'DS-TR0Q1125': // 投资人风险等级不匹配
      handleLowBuyHigh()
      break;
    case 'DS-TR0Q1129':
      handleSlefMsgBack(msg) // 基金风险等级未设置
      break;
    case 'DS-TR140105':
      handleSlefMsgBack(msg) // 交易账号状态是[挂失]、[冻结]、[冻结且挂失]
      break;
    case 'DS-TR0Q1036': // 风险测评过期
      selfMsgBox.error({
        message: t.error,
        messageExtra: '您的风险测评已过期，为保障您的投资安全，请先进行风险测评',
        btns: ['前往测评', '取消'],
        onConfirm: () => {
          router.push({path: '/forget/riskTest'}).catch(err => {})
        },
        onClose: () => {router.go(-1)}
      })
      break;
    case 'DS-TR1353': // 交易密码锁定处理
      selfMsgBox.error({
        message: t.error,
        messageExtra: '您的交易密码已锁定',
        btns: ['立即重置', '取消'],
        onConfirm: () => {
          router.push({
            path: '/forget/choseCard'
          }).catch(err => {})
        },
        onClose: () => {
          // 返回到上一路由
          router.back(-1)
        }
      })
      break;
    case 'DS-TR041353': // 交易密码锁定处理
        selfMsgBox.error({
          message: t.error,
          messageExtra: '您的交易密码已锁定',
          btns: ['立即重置', '返回'],
          onConfirm: () => {
            router.push({
              path: '/forget/choseCard'
            }).catch(err => {})
          },
          onClose: () => {
            // 返回到上一路由
            router.back(-1)
          }
        })
      break;
    default:
      handleSlefMsg(msg)
      break;
  }
}

function checkStatus(response) {
  if (!response || response.status !== 200) {
    selfMsgBox.error({
      message: t.remind,
      messageExtra: '请求错误',
      btns: ['确 认']
    })
    return Promise.reject(response)
  }
  // 密码输入错误
  if (/^DS-TR.+?0102$/.test(response.data.code)) {
    if (response.data.msg.indexOf('|') !== -1) {
      let buyErrorMsg = response.data.msg.split('|')[1]
      handleSlefMsg(buyErrorMsg)
    } else {
      let buyErrorMsg = response.data.msg;
      handleSlefMsg(buyErrorMsg)
    } 
    return Promise.reject(response)
  }
  // DS状态码——直销报错 需抛出
  if (response.data.code == '1') {
    handleSlefMsg(response.data.msg)
    return Promise.reject(response)
  }
  // 直销报错拦截
  if (response.data.code.indexOf('DS') !== -1) {
    handleTradeMsg(response.data.code) // 交易类报错
    handleSwitchDsCode(response.data.code, response.data.msg)
    return Promise.reject(response)
  }
  if (response.data.code == 'NWT-1026' || response.data.code == 'NWT-1024' || response.data.code == 'NWT-1025') {
    handleIdCardStatus(response.data.code, response.data.msg) // 交易类报错
    return Promise.reject(response)
  }
  // 登录请求失败或是登录失效
  if (response.data.code == 'NWT-1002') {
    selfMsgBox.error({
      message: t.error,
      messageExtra: response.data.msg,
      btns: ['重新登录','取消'],
      onConfirm: () => {
        router.push('/login')
      }
    })
    return Promise.reject(response)
  }
  return response.data
}

// 添加请求拦截器
axios.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  return config;
}, err => {
  // 对请求错误做些什么
  return Promise.reject(err);
});

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    return checkStatus(response);
  }, 
  err => {
    if (err.response.status == 500) {
      selfMsgBox.error({
        message: t.error,
        messageExtra: '服务器异常',
        btns: ['确 认']
      })
    } else {
      selfMsgBox.warning({
        message: t.remind,
        messageExtra: err.message,
        btns: ['确 认'],
        onConfirm: function () {
          if(err.response && err.response.status === 401){
            
          }
        }
      })
    }
    return Promise.reject(err);
});

let headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  'X-Requested-With': 'XMLHttpRequest'
}

let timeout = 1000 * 60 * 30

const http = {
  get(url, params = {}) {
    return axios({
      method: 'get',
      url,
      params,
      timeout: timeout,
      headers: headers
    })
  },
  post(url, data = {}) { // eslint-disable-line no-unused-vars
    console.log(url,'---------');
    // 全局入参
    //区分PC与微信
    data.source='pc'
    data.channel = 'web'
    // TODO: 登录写完后需要删除

    // data.clientid = 'd589c586918f756854aa17b376653495yatq'
    // 反洗钱：合规性是否统一入参
    hgx.initHGXParam(url, data)

    // 入参密码加密
    for (const key in data) {
      if (key.indexOf('password') >= 0) {
        const formEncrypt = form.builder(data);
        formEncrypt.encrypt(['password', 'tradepassword', 'newpassword']);
        _datas = formEncrypt.toStr()
        break
      } else {
        _datas = qs.stringify(data)
      }
    }
    let urls = url + '.json'
    return axios({
      method: 'post',
      url: urls,
      data: _datas,
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      timeout: timeout,
      headers: headers
    })
  },
  all(iterable) {
    return axios.all(iterable).then(response => {
      return response
    })
  },
  spread(){
    return axios.spread()
  }
}

export default http